module.exports = __webpack_public_path__ + "img/hospital_black.6a501a55.svg";